if (!customElements.get('quantity-upsell')) {
  customElements.define('quantity-upsell', class QuantityUpsell extends HTMLElement {
    connectedCallback() {
      this._bindCells();
      this._subscribeToPubSub();
    }

    disconnectedCallback() {
      if (this._unsubscribe) this._unsubscribe();
    }

    _bindCells() {
      this.querySelectorAll('.qty-cell').forEach((cell) => {
        cell.addEventListener('click', () => this._onCellClick(cell));
      });
    }

    _onCellClick(cell) {
      const qty = cell.dataset.qty;

      // Update the hidden quantity-input inside product-info
      const input = document.querySelector('product-info quantity-input input');
      if (input) input.value = qty;

      // Update selected state on all cells
      this.querySelectorAll('.qty-cell').forEach((c) => c.classList.remove('selected'));
      cell.classList.add('selected');

      // Update label and price display
      const qtyLabel = document.querySelector(this.dataset.qtyLabel || '.qty-num');
      const priceLabel = document.querySelector(this.dataset.priceLabel || '.cta-price');
      if (qtyLabel) qtyLabel.innerText = qty;
      if (priceLabel) {
        const ctaValue = cell.querySelector('.cta-value');
        if (ctaValue) priceLabel.innerText = ' ' + ctaValue.innerText;
      }
    }

    _restoreSelection() {
      const selected = this.querySelector('.qty-cell.selected');
      if (!selected) return;
      const input = document.querySelector('product-info quantity-input input');
      if (input) input.value = selected.dataset.qty;
    }

    _subscribeToPubSub() {
      if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS?.cartUpdate) return;
      this._unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this._restoreSelection();
      });
    }
  });
}
